import React from "react";
import { Table } from "antd";
import { CustomTitle } from "../../../components";

const SWminimumTime = ({ data }) => {
  if (!data || !data.domesticHandlingTime || !data.internationalHandlingTime) {
    return <p>No data available</p>;
  }

  // Function to get handling time
  const getHandlingTime = (serviceKey, type) => {
    const domesticTime = data.domesticHandlingTime;
    const internationalTime = data.internationalHandlingTime;
  
    return {
      domestic: domesticTime?.[`${serviceKey}${type}`] || "N/A",
      international: internationalTime?.[`${serviceKey}${type}`] || "N/A",
    };
  };
  
  // Extract full service+type keys dynamically
  const serviceKeys = new Set([
    ...Object.keys(data.domesticHandlingTime || {}),
    ...Object.keys(data.internationalHandlingTime || {}),
  ]);
  
  // Data source for the table
  const dataSource = Array.from(serviceKeys).map((fullKey, index) => {
    const match = fullKey.match(/(nfg|ff|ss)(CutOffTime|RecoveryTime)/i);
  
    if (!match) return null; // ignore invalid keys
  
    const serviceKey = match[1];
    const type = match[2];
  
    // Friendly service names (optional mapping)
    const serviceNameMap = {
      nfg: "NFG",
      ff: "FRESH FAST",
      ss: "SOUTHWEST STANDARD",
    };
  
    const typeNameMap = {
      CutOffTime: "Cut Off Time",
      RecoveryTime: "Recovery Time",
    };
  
    return {
      key: String(index + 1),
      service: `${serviceNameMap[serviceKey.toLowerCase()] || serviceKey.toUpperCase()} - ${typeNameMap[type] || type}`,
      ...getHandlingTime(serviceKey, type),
    };
  }).filter(Boolean); // remove any nulls
  
  // Table columns
  const columns = [
    {
      title: "Service",
      dataIndex: "service",
      key: "service",
    },
    {
      title: "US Domestic",
      dataIndex: "domestic",
      key: "domestic",
      render: (text) => (text !== "N/A" ? `${text} min` : "N/A"),
    },
    {
      title: "International",
      dataIndex: "international",
      key: "international",
      render: (text) => (text !== "N/A" ? `${text} min` : "N/A"),
    },
  ];
  
  

  return (
    <div className="p-4 bg-white shadow rounded-lg">
      <CustomTitle
        text="Minimum times"
        fontSize="16px"
        fontWeight="600"
        lineHeight="20px"
        color="black"
        marginBottom="20px"
      />
      <Table
        className="zl-custom-times-table"
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        bordered
      />
    </div>
  );
};

export default SWminimumTime;
